import React, { useEffect } from 'react';
import { useSelector } from "react-redux";

const Communicator = () => {
    const { ASCSSettingData, GlobalASCSData } = useSelector((store) => store.combinedata);

    useEffect(() => {

        const receiveMessage = (event) => {   
            try{
                // Security check: validate origin
                
                const isFirefox = typeof navigator !== "undefined" && /firefox/i.test(navigator.userAgent); 
                const jsonData = (isFirefox ? JSON.stringify(ASCSSettingData) : '');
                const parentStorage = window.parent.parent.localStorage;
                let storedSelection = parentStorage.getItem("affSelectedCallAgent") ? JSON.parse(parentStorage.getItem("affSelectedCallAgent")).data : null;
                const targetAffJSONFireFox = (isFirefox ? JSON.parse(jsonData)[storedSelection] : null);
                const CCProfileURL1 = (targetAffJSONFireFox ? JSON.parse(targetAffJSONFireFox).find((item)=>item.SubTitle === "CCOnProfileAuthorizeNetAddCardReuestURL").value : '');
                const CCProfileURL2 = (targetAffJSONFireFox ? JSON.parse(targetAffJSONFireFox).find((item)=>item.SubTitle === "CCOnProfileAuthorizeNetPaymentReuestURL").value : '');
                
                let mainURLArr = [];
                
                const AuthorizeNetURL =  (isFirefox ? CCProfileURL1 : (storedSelection && ASCSSettingData[storedSelection] ? 
                    (JSON.parse(ASCSSettingData[storedSelection]).find((item)=>item.SubTitle === "CCOnProfileAuthorizeNetAddCardReuestURL").value) : 
                    (JSON.parse(ASCSSettingData["-1"]).find((item)=>item.SubTitle === "CCOnProfileAuthorizeNetAddCardReuestURL").value)
                ));
                const AuthorizeNetURL2 = (isFirefox ? CCProfileURL2 : (storedSelection && ASCSSettingData[storedSelection] ? 
                    (JSON.parse(ASCSSettingData[storedSelection]).find((item)=>item.SubTitle === "CCOnProfileAuthorizeNetPaymentReuestURL").value) : 
                    (JSON.parse(ASCSSettingData["-1"]).find((item)=>item.SubTitle === "CCOnProfileAuthorizeNetPaymentReuestURL").value)
                ));
                let firstURL = new URL(AuthorizeNetURL).origin;
                let secondURL = new URL(AuthorizeNetURL2).origin;
                mainURLArr = [firstURL, secondURL];
                if (!mainURLArr.includes(event.origin)) {
                    // console.warn('Blocked message from unknown origin:', event.origin);
                    return;
                }
        
                // Call the parent function (window.parent.parent.CommunicationHandler)
                if (event.data && typeof event.data === 'string' && event.data.includes("action")) {

                    const parentStorage = window.parent.parent.sessionStorage;
                    const qstr = {action:event.data, response:(event.response? event.response : "")};
                    // console.log("this is the whole event communicator:", event.data, event.response);
                    if(parentStorage)
                    {
                        parentStorage.setItem("authorizeAction", JSON.stringify(qstr));
                        // console.log(`Data saved in parent sessionStorage: authorizeAction = ${qstr}`);
                    }
                }
            }
            catch(err){console.log(err);}
        };
        // Attach message listener
        window.addEventListener('message', receiveMessage);

        return () => {
            // Cleanup listener on component unmount
            window.removeEventListener('message', receiveMessage);
        };
    }, []); // Empty dependency array ensures this runs only once

    return null; // This component doesn't render anything visually
};

export default Communicator;